import React from 'react';
import './QuickSearch.css';

const QuickSearch = ({
  quickSearch,
  onQuickSearchChange,
  quickSearchResults,
  onQuickDraft,
  getPositionDisplay
}) => {
  return (
    <div className="quick-search-section">
      <div className="quick-search-container">
        <input
          type="text"
          className="quick-search-input"
          placeholder="Quick search players..."
          value={quickSearch}
          onChange={(e) => onQuickSearchChange(e.target.value)}
        />
        {quickSearchResults.length > 0 && (
          <div className="quick-search-results">
            {quickSearchResults.map((player, index) => (
              <div
                key={index}
                className="quick-search-item"
                onClick={() => onQuickDraft(player)}
              >
                <span className="player-name">{player.name}</span>
                <span className="player-position">{getPositionDisplay(player, 'BENCH')}</span>
                <span className="player-team">{player.team}</span>
                <span className="player-projected">{player.projected.toFixed(1)}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default QuickSearch;